import React from 'react';
import reactDOM from 'react-dom';
import App from './components/App';
import './components/Complete.css';


 reactDOM.render(<App />, document.getElementById("root"));